export enum ActivityVerbEnum {
  Commented = 1,                  // 1        [Description("ثبت نظر")];
  Followed,                       // 2        [Description("دنبال کردن")];
  Liked,                          // 3        [Description("پسندیدن")];
  Quoted,                         // 4        [Description("بریدۀ کتاب")];
  Rated,                          // 5        [Description("امتیاز داده شده")];
  Reviewed,                       // 6        [Description("ریویو ساخته شده")];
  Posted,                         // 7        [Description("یک پست صورت گرفته")];
  Chanllenged,                    // 8        [Description("چالش ایجاد شده است")];
  Shared,                         // 9        [Description("اشتراک گذار صورت کرفته است")];
  StateChanged,                   // 10       [Description("تغییر وضعیت کتاب")];
  ReadingProgressed,              // 11       [Description("گزارش مطالعه")];
  StateChangedIWantToRead,        // 12       [Description("وضعیت می‌خواهد بخواند")];
  StateChangedToCurrently,        // 13       [Description("وضعیت درحال خواند")];
  StateChangedToRead,             // 14       [Description("وضعیت خوانده است")];
  Storied,                        // 15       [Description("یک استوری صورت گرفته")]
  Mentioned,                      // 16       [Description("یک منشن صورت گرفته")]
  Booklisted,                     // 17       [Description("یک لیست کتاب صورت گرفته")]
  Joined = 18,                    // 18       [Description("وضعیت پیوستن")];
  Clubed,                         // 19       [Description] یک باشگاه کتاب خوانی ایجاد شده
  ClubInvited,                    // 20       [Description] از یک کاربر برای عضویت به باشگاه دعوت شده
  ClubJoinRequested,              // 21       [Description] یک کاربر درخواست عضویت به یک باشگاه خصوصی داده
  Coursed,                        // 22       [Description] یک دورۀ مطالعاتی در باشگاه ایجاد شده
  CourseEnded,                    // 23       [Description] یک دورۀ مطالعاتی در باشگاه پایان یافت
  Polled,                         // 24       [Description]یک نظرسنجی در باشگاه ایجاد شده
  PollClosed,                     // 25       [Description] یک نظرسنجی در باشگاه بسته شده
  Meetinged,                      // 26       [Description] یک رویداد در باشگاه ایجاد شده
  ClubJoinRequestAccepted,        // 27       [Description] یک درخواست عضویت تایید شده
  ChallengePicked,                // 28       [Description] یک کاربر یک چالش را شرووع کردن
  ChallengeObtained,              // 29       [Description] یک کاربر یک چالش را به پایان رساند
  AchievementObtained,            // 30       [Description] یک کاربر یک دستاورد بدست آورد
  Reminder,                       // 31       [Description]
  Reacted,                        // 32       [Description] لایک کامنت و یا ری اکشن های دیگر
  UserReportPublished,            // 33       [Description] انتشار گزارش سالانه کاربر
  BookRequestAccepted, //34
  ChallengeFailed = 35,                // 35       [Description] اگر امروز گزارش مطالعه خود را ثبت نکنید، چالش خود را از دست خواهید داد!
  FollowRequested = 36, //36 
  LibrarianAccept = 37,              // 37       [Description] تایید درخواست کتابداری
  bloggerAccept = 38,              // 38       [Description] تایید درخواست بلاگری


  banner = 50,                    // 50       [Description] بنر خوش آمد گویی
  bannerList,                     // 51       [Description] بنرهای ژانرها
  genreList,                      // 52       [Description] ژانرها
  userList,                       // 53       [Description] کاربران فعال
  authorList,                     // 54       [Description] کاربران فعال
  bookList,                       // 55       [Description] کتاب
  latestPosts,                    // 56       [Description] آخرین پست‌ها
  latestReviews,                  // 57       [Description] آخرین یادداشت‌ها
  International,                  // 58       [Description] نمایشگاه بین المللی کتاب
  guids,                          // 59       [Description] راهنمای بهخوان
  latestBooklists,                // 59       [Description] آخرین لیست کتابها
  latestQuotelists,               // 60       [Description] آخرین لیست بریدۀ کتاب‌ها


  suggestedClub = 100
}
